// @ts-expect-error Untyped module
import Cookies from 'js-cookie';
import { getIsThemePreview, getPortalAccountId, getPortalInstanceId, getPreviewJwt } from './utils/metadata';
const portalsHttpClient = createPortalsHttpClient({
  prefix: '/_hcms/portals-platform'
});
const isThemePreview = getIsThemePreview();
const previewJwt = getPreviewJwt();
export default portalsHttpClient;
export function createPortalsHttpClient({
  prefix
}) {
  return {
    post: async (url, options) => {
      var _Cookies$get;
      const requestUrl = new URL(url, window.location.origin);
      const resolvedPath = requestUrl.pathname;
      let clientInfo = {
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId()
      };
      if (isThemePreview) {
        clientInfo = {
          previewJwt
        };
      }
      const queryString = options !== null && options !== void 0 && options.query ? `?${new URLSearchParams(options.query).toString()}` : '';
      const proxiedUrl = `${prefix}${resolvedPath}${queryString}`;
      const data = await fetch(proxiedUrl, {
        method: 'POST',
        credentials: 'include',
        headers: Object.assign({
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }, options === null || options === void 0 ? void 0 : options.headers, {
          'X-Hs-Membership-Csrf': (_Cookies$get = Cookies.get('__Host-hs-membership-csrf')) !== null && _Cookies$get !== void 0 ? _Cookies$get : Cookies.get('hs-membership-csrf')
        }),
        body: JSON.stringify(options !== null && options !== void 0 && options.data ? Object.assign({}, options.data, clientInfo) : Object.assign({}, clientInfo))
      });
      return data.json();
    },
    get: () => {
      throw new Error('Only POST requests are supported');
    },
    delete: () => {
      throw new Error('Only POST requests are supported');
    },
    put: () => {
      throw new Error('Only POST requests are supported');
    },
    patch: () => {
      throw new Error('Only POST requests are supported');
    }
  };
}